import { createReducer, on } from '@ngrx/store';
import { FullscreenLayoutAreas } from '@src/assets/css/fullscreen.template.scss';
import { FullscreenActions, SecondSidecarActions, SidecarEfffectActions } from '@src/suite/common/store/fullscreen/actions/fullscreen.actions';
import { SidecarMenu, SidecarState } from '@src/suite/common/store/fullscreen/models/fullscreen.models';

import { BASE_SIDECAR_INITIAL_STATE } from './fullscreen.reducer';

export const secondSidecarInitialState: SidecarState = {
    ...BASE_SIDECAR_INITIAL_STATE,
};

export const secondSidecarReducer = createReducer(
    secondSidecarInitialState,
    on(
        FullscreenActions.resetState,
        (): SidecarState => ({
            ...secondSidecarInitialState,
        })
    ),
    on(
        SecondSidecarActions.selectSidecarMenu,
        (state, { menu }): SidecarState => ({
            ...state,
            selected: menu,
        })
    ),
    on(
        SecondSidecarActions.selectSidecarAssignment,
        (state, { assignmentGuid }): SidecarState => ({
            ...state,
            selected: SidecarMenu.ASSIGNMENTS,
            selectedAssignmentGuid: assignmentGuid,
        })
    ),
    on(SecondSidecarActions.setAssignmentViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedAssignmentViewStates: viewStates,
        };
    }),
    on(SecondSidecarActions.setCurrentAssignmentViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentAssignmentViewStateGuid: guid || null,
        };
    }),
    on(SecondSidecarActions.setAssignmentListGuids, (state, { assignmentGuids: topicGuids }): SidecarState => {
        return {
            ...state,
            assignmentListGuids: topicGuids,
        };
    }),
    on(SecondSidecarActions.setTopicViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedTopicViewStates: viewStates,
        };
    }),
    on(SecondSidecarActions.setCurrentTopicViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentTopicViewStateGuid: guid || null,
        };
    }),
    on(SecondSidecarActions.setTopicListGuids, (state, { topicGuids }): SidecarState => {
        return {
            ...state,
            topicListGuids: topicGuids,
        };
    }),
    on(SecondSidecarActions.setRundownViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedRundownViewStates: viewStates,
        };
    }),
    on(SecondSidecarActions.setCurrentRundownViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentRundownViewStateGuid: guid || null,
        };
    }),
    on(SecondSidecarActions.setRundownListGuids, (state, { rundownGuids }): SidecarState => {
        return {
            ...state,
            rundownListGuids: rundownGuids,
        };
    }),
    on(
        SecondSidecarActions.selectSidecarStory,
        (state, { guid }): SidecarState => ({
            ...state,
            selected: SidecarMenu.STORIES,
            selectedStoryGuid: guid,
        })
    ),
    on(SecondSidecarActions.setStoryViewStates, (state, { viewStates }): SidecarState => {
        return {
            ...state,
            storedStoryViewStates: viewStates,
        };
    }),
    on(SecondSidecarActions.setCurrentStoryViewState, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentStoryViewStateGuid: guid || null,
        };
    }),
    on(SecondSidecarActions.setStoryListGuids, (state, { storyGuids }): SidecarState => {
        return {
            ...state,
            storyListGuids: storyGuids,
        };
    }),
    on(SecondSidecarActions.selectSidecarRundown, (state, { guid }): SidecarState => {
        return {
            ...state,
            selectedRundownGuid: guid,
        };
    }),
    on(SecondSidecarActions.selectSidecarTopic, (state, { guid }): SidecarState => {
        return {
            ...state,
            selectedTopicGuid: guid,
        };
    }),
    on(SecondSidecarActions.setCurrentROSelectedStory, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentRundownSelectedStoryGuid: guid,
        };
    }),
    on(SecondSidecarActions.setCurrentTopicSelectedStory, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentTopicSelectedStoryGuid: guid,
        };
    }),
    on(SecondSidecarActions.setCurrentTopicSelectedAssignment, (state, { guid }): SidecarState => {
        return {
            ...state,
            currentTopicSelectedAssignmentGuid: guid,
        };
    }),
    on(
        SecondSidecarActions.setCurrentMosPlugin,
        (state, { mosPluginId: mosId }): SidecarState => ({
            ...state,
            selectedMosPluginID: mosId,
            selectedMosPluginInitialized: false,
        })
    ),
    on(
        SecondSidecarActions.resetMosState,
        (state): SidecarState => ({
            ...state,
            selectedMosPluginID: null,
            selectedMosPluginInitialized: false,
            selectedMosPluginPendingCommand: null,
        })
    ),
    on(
        SecondSidecarActions.setAssignmentsListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedAssignmentListSearchType: searchType,
        })
    ),
    on(
        SecondSidecarActions.setStoriesListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedStoryListSearchType: searchType,
        })
    ),
    on(
        SecondSidecarActions.setTopicsListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedTopicListSearchType: searchType,
        })
    ),
    on(
        SecondSidecarActions.setRundownsListSearchType,
        (state, { searchType }): SidecarState => ({
            ...state,
            selectedRundownListSearchType: searchType,
        })
    ),
    on(SidecarEfffectActions.openMosItemInSidecar, (state, { mosPluginId, mosItemCommand, sidecar }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_SECOND) {
            return {
                ...state,
                selectedMosPluginID: mosPluginId,
                selectedMosPluginPendingCommand: mosItemCommand,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.openPendingMosItem, (state, { mosPluginId, sidecar }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_SECOND && mosPluginId === state.selectedMosPluginID) {
            return {
                ...state,
                selectedMosPluginPendingCommand: null,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.setCurrentMosPluginInitialized, (state, { mosPluginId, sidecar }): SidecarState => {
        if (mosPluginId === state.selectedMosPluginID && sidecar === FullscreenLayoutAreas.SIDECAR_SECOND) {
            return {
                ...state,
                selectedMosPluginInitialized: true,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.setRundownLayout, (state, { roGuid, layout, sidecar }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_SECOND) {
            const rundownState = new Map(state.rundownState);
            rundownState.set(roGuid, { selectedLayoutName: layout.name, selectedLayoutType: layout.type });
            return {
                ...state,
                rundownState,
            };
        }
        return state;
    }),
    on(SidecarEfffectActions.openSubStoriesInSidecar, (state, { sidecarType, parentGuid }): SidecarState => {
        if (sidecarType === FullscreenLayoutAreas.SIDECAR_SECOND) {
            return { ...state, subStoriesParentGuid: parentGuid || null };
        }
        return state;
    }),
    on(SidecarEfffectActions.setCurrentSubStories, (state, { sidecarType, parentGuid }): SidecarState => {
        if (sidecarType === FullscreenLayoutAreas.SIDECAR_SECOND) {
            return { ...state, subStoriesParentGuid: parentGuid };
        }
        return state;
    }),
    on(SidecarEfffectActions.clearStoryFromSidecar, (state, { sidecar, excludedMenus }): SidecarState => {
        if (sidecar === FullscreenLayoutAreas.SIDECAR_SECOND) {
            const newState = {
                ...state,
            };
            if (excludedMenus?.length) {
                excludedMenus.forEach(menu => {
                    switch (menu) {
                        case SidecarMenu.STORIES:
                            newState.currentRundownSelectedStoryGuid = null;
                            newState.currentTopicSelectedStoryGuid = null;
                            break;
                        case SidecarMenu.RUNDOWNS:
                            newState.selectedStoryGuid = null;
                            newState.currentTopicSelectedStoryGuid = null;
                            break;
                        case SidecarMenu.TOPICS:
                            newState.selectedStoryGuid = null;
                            newState.currentRundownSelectedStoryGuid = null;
                            break;
                    }
                });
                return newState;
            }
            newState.selectedStoryGuid = null;
            newState.currentRundownSelectedStoryGuid = null;
            newState.currentTopicSelectedStoryGuid = null;
            return newState;
        }
        return state;
    })
);
